import React from 'react';
import Icon from '../../../components/AppIcon';

const ErrorNotification = ({ errors, onDismiss }) => {
  if (!errors || errors?.length === 0) return null;

  return (
    <div className="space-y-3">
      {errors?.map((error, index) => (
        <div
          key={index}
          className="flex items-start gap-3 p-4 bg-destructive/10 border border-destructive/20 rounded-xl"
        >
          <Icon name="XCircle" size={20} color="var(--color-destructive)" className="mt-0.5 flex-shrink-0" />
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium text-destructive mb-1">{error?.title}</p>
            <p className="text-xs text-muted-foreground caption">{error?.message}</p>
            {error?.suggestion && (
              <p className="text-xs text-foreground caption mt-2 flex items-center gap-1">
                <Icon name="Lightbulb" size={14} color="var(--color-primary)" />
                {error?.suggestion}
              </p>
            )}
          </div>
          <button
            onClick={() => onDismiss(index)}
            className="flex-shrink-0 p-1 hover:bg-muted rounded transition-smooth"
            aria-label="Dismiss error"
          >
            <Icon name="X" size={16} color="var(--color-muted-foreground)" />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ErrorNotification;